import { FC } from 'react';

import { Button, ButtonVariant } from '@pp/core/src/components/controls/button/Button';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import styles from './ErrorMessage.module.css';

interface ErrorMessageProps {
  title: string;
  message: string;
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ title, message, disabled, loading, onClick }) => {
  return (
    <div className={styles.errorMessage_container}>
      <div className={styles.title}>
        <L10nText tk={title} />
      </div>
      <div className={styles.message}>
        <L10nText tk={message} />
      </div>
      <div className={styles.reloadButton}>
        <Button tk="RELOAD" variant={ButtonVariant.MAIN} disabled={disabled} loading={loading} onClick={onClick} />
      </div>
    </div>
  );
};
